export default __webpack_public_path__ + "static/secure-checkout-d1269c41.png";